export enum ProjectRole {
  PRIMARY_LENDER = "PRIMARY_LENDER",
  PRIMARY_BUILDER = "PRIMARY_BUILDER",
  PRIMARY_BORROWER = "PRIMARY_BORROWER",
  PRIMARY_INSPECTOR = "PRIMARY_INSPECTOR",
  LENDER = "LENDER",
  BUILDER = "BUILDER",
  BORROWER = "BORROWER",
  INSPECTOR = "INSPECTOR",
  TITLE_COMPANY = "TITLE_COMPANY",
  PROCESSOR = "PROCESSOR",
  CONTACT = "CONTACT",
  INSURER = "INSURER",
  APPRAISER = "APPRAISER",
  SURVEYOR = "SURVEYOR",
  LOAN_OFFICER = "LOAN_OFFICER",
  INVESTOR_FUNDS = "INVESTOR_FUNDS",
  CONTRACTOR = "CONTRACTOR",
  BUYER = "BUYER",
}

export function entityIsLender(role: ProjectRole | null | undefined) {
  return role != null && (role === ProjectRole.PRIMARY_LENDER || role === ProjectRole.LENDER);
}

export function entityIsBuilder(role: ProjectRole | null | undefined) {
  return role != null && (role === ProjectRole.PRIMARY_BUILDER || role === ProjectRole.BUILDER);
}

export function entityIsBorrower(role: ProjectRole | null | undefined) {
  return role != null && (role === ProjectRole.PRIMARY_BORROWER || role === ProjectRole.BORROWER);
}

export function entityIsInspector(role: ProjectRole | null | undefined) {
  return role != null && (role === ProjectRole.PRIMARY_INSPECTOR || role === ProjectRole.INSPECTOR);
}

export const getRoleDisplayTextFromString = (roleText: string): string => {
  const role = getProjectRoleFromDisplayText(roleText);
  return role == null ? "" : getRoleDisplayText(role);
};

export const getRoleDisplayText = (role: ProjectRole | null | undefined): string => {
  switch (role) {
    case ProjectRole.PRIMARY_LENDER:
      return "Primary Lender";
    case ProjectRole.PRIMARY_BUILDER:
      return "Primary Builder";
    case ProjectRole.PRIMARY_BORROWER:
      return "Primary Borrower";
    case ProjectRole.PRIMARY_INSPECTOR:
      return "Primary Inspector";
    case ProjectRole.LENDER:
      return "Lender";
    case ProjectRole.BUILDER:
      return "Builder";
    case ProjectRole.BORROWER:
      return "Borrower";
    case ProjectRole.INSPECTOR:
      return "Inspector";
    case ProjectRole.TITLE_COMPANY:
      return "Title Company";
    case ProjectRole.PROCESSOR:
      return "Processor";
    case ProjectRole.CONTACT:
      return "Contact";
    case ProjectRole.INSURER:
      return "Insurer";
    case ProjectRole.APPRAISER:
      return "Appraiser";
    case ProjectRole.SURVEYOR:
      return "Surveyor";
    case ProjectRole.LOAN_OFFICER:
      return "Loan Officer";
    case ProjectRole.INVESTOR_FUNDS:
      return "Investor Funds";
    case ProjectRole.CONTRACTOR:
      return "Contractor";
    case ProjectRole.BUYER:
      return "Buyer";
    default:
      return "";
  }
};

export const getProjectRoleFromDisplayText = (displayText: string): ProjectRole | null => {
  let text = displayText.toUpperCase().replace(" ", "_");
  if (Object.values(ProjectRole).includes(text as ProjectRole)) {
    return text as ProjectRole;
  } else {
    return null;
  }
};

export const getContactRoleOptions = (): string[] => {
  return [
    getRoleDisplayText(ProjectRole.APPRAISER),
    getRoleDisplayText(ProjectRole.BUYER),
    getRoleDisplayText(ProjectRole.CONTACT),
    getRoleDisplayText(ProjectRole.CONTRACTOR),
    getRoleDisplayText(ProjectRole.INSURER),
    getRoleDisplayText(ProjectRole.INVESTOR_FUNDS),
    getRoleDisplayText(ProjectRole.LOAN_OFFICER),
    getRoleDisplayText(ProjectRole.SURVEYOR),
    getRoleDisplayText(ProjectRole.TITLE_COMPANY),
  ];
};
